// © 2024–2026 Jos Jozef Sytze van der Werf — Alle rechten voorbehouden.
export function Step1Welcome() {
  const VALUE_CARDS = [
    {
      emoji:   '🧩',
      bg:      'bg-amber-50',
      title:   'U bepaalt wat u invult',
      desc:    'Alleen wat voor u van toepassing is. De rest kunt u overslaan of later doen.',
    },
    {
      emoji:   '🔒',
      bg:      'bg-blue-50',
      title:   'Veilig op uw apparaat',
      desc:    'Uw gegevens blijven op dit apparaat. Niets gaat naar de cloud zonder uw toestemming.',
    },
    {
      emoji:   '🪜',
      bg:      'bg-sage-50',
      title:   'Stap voor stap',
      desc:    'We lopen de onderdelen samen langs, in korte stappen.',
    },
  ]

  return (
    <div className="flex flex-col gap-5">

      {/* Logo + opening */}
      <div className="flex flex-col items-center text-center">
        <div className="flex h-14 w-14 items-center justify-center rounded-2xl bg-moss shadow-card mb-4">
          <span className="text-2xl">🍃</span>
        </div>
        <h2 className="text-xl font-semibold text-ink mb-2 leading-snug">
          We maken eerst uw profiel aan
        </h2>
        <p className="text-sm text-ink-3 leading-relaxed max-w-xs">
          Dit is de start. In een paar korte stappen legt u de basisgegevens vast.
          U vult alleen in wat voor u van toepassing is, uw gegevens blijven veilig op uw eigen apparaat, en u kunt altijd later verdergaan.
        </p>
      </div>

      {/* Drie waarde-kaarten */}
      <div className="flex flex-col gap-3">
        {VALUE_CARDS.map(c => (
          <div key={c.title}
            className={`flex items-start gap-3 rounded-xl ${c.bg} px-4 py-3 border border-sand-200`}>
            <span className="text-2xl flex-shrink-0 mt-0.5">{c.emoji}</span>
            <div>
              <p className="text-sm font-semibold text-ink">{c.title}</p>
              <p className="text-xs text-ink-3 mt-0.5 leading-relaxed">{c.desc}</p>
            </div>
          </div>
        ))}
      </div>

      {/* Geruststelling */}
      <div className="rounded-xl bg-sage-50 border border-sage-200 px-4 py-3 flex flex-col gap-2">
        {[
          { emoji: '✅', text: 'Niets is verplicht - u vult in wat voor u van toepassing is' },
          { emoji: '⏸️', text: 'U kunt altijd stoppen en later verdergaan' },
          { emoji: '⏱️', text: 'Binnen 10 tot 15 minuten een eerste overzicht' },
        ].map(item => (
          <div key={item.text} className="flex items-center gap-2.5">
            <span className="text-base flex-shrink-0">{item.emoji}</span>
            <span className="text-xs text-sage-800 leading-relaxed">{item.text}</span>
          </div>
        ))}
      </div>

      <p className="text-xs text-ink-4 text-center leading-relaxed">
        WilsApp is een hulpmiddel, geen juridisch systeem en geen vervanging van een notaris, de overheid of officiële registraties.<br />
        Het helpt u overzicht te creëren en bewuste keuzes te maken.
      </p>

    </div>
  )
}
